import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ShopForgotPasswordPage.css';

const isValidEmail = (e) => /^\S+@\S+\.\S+$/.test(e.trim());

export default function ShopForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [phase, setPhase] = useState('form'); // form | sending | sent

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setError('Voer een geldig e-mailadres in');
      return;
    }
    setError('');
    setPhase('sending');
    setTimeout(() => setPhase('sent'), 1400);
  };

  return (
    <div className="shop-fp">
      <header className="shop-fp__header">
        <button
          className="shop-fp__back"
          onClick={() => navigate('/shop/login')}
          aria-label="Terug"
        >
          ←
        </button>
        <span className="shop-fp__spacer" />
      </header>

      <div className="shop-fp__content">
        <div className="shop-fp__logo">
          <span className="shop-fp__logo-walk">Walk</span>
          <span className="shop-fp__logo-in">In</span>
        </div>
        <div className="shop-fp__badge">Winkeliers modus 🏪</div>

        {phase !== 'sent' ? (
          <>
            <h1 className="shop-fp__title">Wachtwoord vergeten</h1>
            <p className="shop-fp__sub">
              Vul je e-mailadres in en we sturen je een link om je wachtwoord
              te resetten.
            </p>

            <form className="shop-fp__form" onSubmit={handleSubmit}>
              <label className="shop-fp__field">
                <span className="shop-fp__label">E-mailadres</span>
                <input
                  type="email"
                  className="shop-fp__input"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(''); }}
                  placeholder="naam@winkel.nl"
                  autoComplete="email"
                  required
                />
                {error && <em className="shop-fp__err">{error}</em>}
              </label>

              <button
                type="submit"
                className="shop-fp__submit"
                disabled={phase === 'sending'}
              >
                {phase === 'sending' ? 'Resetlink wordt verstuurd...' : 'Stuur resetlink'}
              </button>
            </form>
          </>
        ) : (
          <div className="shop-fp__success">
            <div className="shop-fp__success-icon">📧</div>
            <h2 className="shop-fp__success-title">Resetlink verstuurd!</h2>
            <p className="shop-fp__success-sub">
              We hebben een e-mail gestuurd naar <strong>{email}</strong> met
              een link om je wachtwoord te resetten. Controleer ook je
              spamfolder.
            </p>

            <section className="shop-fp__email-preview">
              <div className="shop-fp__email-head">
                <div><strong>VAN:</strong> noreply@walkin.nl</div>
                <div><strong>AAN:</strong> {email}</div>
                <div><strong>ONDERWERP:</strong> Reset je WalkIn wachtwoord</div>
              </div>
              <div className="shop-fp__email-body">
                <p>Beste winkelier,</p>
                <p>
                  We hebben een verzoek ontvangen om het wachtwoord van je
                  WalkIn account te resetten.
                </p>
                <p>Klik op de knop om een nieuw wachtwoord in te stellen:</p>
                <p>
                  <button
                    type="button"
                    className="shop-fp__email-cta"
                    onClick={() => navigate('/shop/reset-password')}
                  >
                    Reset mijn wachtwoord →
                  </button>
                </p>
                <p>Deze link is 24 uur geldig.</p>
                <p>
                  Als jij dit niet hebt aangevraagd, kun je deze e-mail
                  negeren.
                </p>
                <p>Met vriendelijke groet,<br />Team WalkIn</p>
              </div>
            </section>

            <button
              className="shop-fp__submit"
              onClick={() => navigate('/shop/login')}
            >
              Terug naar inloggen →
            </button>
            <button
              className="shop-fp__retry"
              onClick={() => setPhase('form')}
            >
              Geen e-mail ontvangen? Probeer opnieuw
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
